/**
 * Event emitter singleton for application-wide event handling.
 * Provides a centralized event bus for component communication.
 * @module core/ee
 */

/**
 * Simple event emitter implementation
 */
class EventEmitter {
  constructor() {
    this.events = {}
  }

  /**
   * Add event listener
   * @param {string} event - Event name
   * @param {Function} callback - Event handler
   */
  addListener(event, callback) {
    if (!this.events[event]) {
      this.events[event] = []
    }
    this.events[event].push(callback)
    return this
  }

  /**
   * Remove event listener
   * @param {string} event - Event name
   * @param {Function} callback - Event handler to remove
   */
  removeListener(event, callback) {
    if (this.events[event]) {
      this.events[event] = this.events[event].filter((cb) => cb !== callback)
    }
    return this
  }

  /**
   * Emit event with data
   * @param {string} event - Event name
   * @param {...any} args - Event data
   */
  emit(event, ...args) {
    if (this.events[event]) {
      this.events[event].forEach((callback) => {
        callback(...args)
      })
    }
    return this
  }
}

/**
 * Global event emitter instance
 * @type {EventEmitter}
 */
const ee = new EventEmitter()

export default ee
